import React from 'react'
import ReqStyle from "./AllRequest.module.css"
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Button from '@mui/material/Button'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FilterListIcon from '@mui/icons-material/FilterList';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useEffect } from 'react';
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";



// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid gray',
    boxShadow: '2px 2px 10px 2px gray',
    borderRadius: '5px',
    p: 4,
};

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

function AllRequest() {

    // get data from redux
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const [filteredData, setFilteredData] = useState([])
    const [open, setOpen] = useState(false);
    const handleOpen = (row) => {
        setOpen(true)
        setSelectedData(row)
    };
    const handleClose = () => setOpen(false);

    const [query, setQuery] = useState("");

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [rowCount, setRowCount] = useState(10);
    const [entryCount, setEntryCount] = useState("");



    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const [data, setData] = useState([])
    const [filterQuery, setFilterQuery] = useState("")
    const [selectedData, setSelectedData] = useState({})


    const [clicked, setclicked] = useState(null);

    const [jobRole, setJobRole] = React.useState("");

    const handleJobRoles = (event) => {
        setJobRole(event.target.value);
    };



    const getReqData = async () => {

        try {
            const res = await axios.get(
                `${process.env.REACT_APP_STEELADMIN}/corporate/getAllCorporateUsers`
            ).then(async (res) => {

                const res2 = await axios.get(
                    `${process.env.REACT_APP_STEELADMIN}/vendor/getAllVendor`
                ).then((res2) => {
                    const updateArray = res.data.concat(res2.data);
                    setData(updateArray)



                })


            })



        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        let count = 0;
        data.forEach((tt) => {
            if (!tt.approved && tt.requested) {
                count += 1;
            }
        })
        setEntryCount(count);
    }, [data])
    useEffect(() => {
        getReqData();
    }, [])


    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };



    useEffect(() => {
        const fill = data.filter(row => row?.roles?.name.includes(jobRole)).reverse();
        let count = 0;

        fill.map((tt) => {
            if (!tt.approved && tt.requested) {
                count += 1;
            }
        })
        setFilteredData(fill)
        setRowCount(count)


    }, [jobRole, data])


    useEffect(() => {

        setPage(0);
    }, [data, query, filteredData])

    return (
        <>
            <Card sx={{ maxWidth: '95%', border: 'none', outline: 'none', boxShadow: 'none', mt: '3%' }}>
                <CardContent>
                    <Paper className={ReqStyle.myboder}>
                        <TableContainer sx={{ maxHeight: 650 }}>
                            <div className={ReqStyle.USerListBox1}>
                                <Box className={ReqStyle.Box1}>
                                    <Typography variant='h5'>Pending Approval</Typography>
                                    <Typography variant='h6'>{entryCount} entries</Typography>
                                </Box>
                            </div>
                            <div className={ReqStyle.USerListBox2}>
                                <Box className={ReqStyle.Box1}>
                                    <Search>
                                        <SearchIconWrapper>
                                            <SearchIcon sx={{ zIndex: '1', color: '#727374' }} />
                                        </SearchIconWrapper>
                                        <StyledInputBase
                                            placeholder="Search…"
                                            onChange={(e) => setQuery(e.target.value)}
                                            inputProps={{ 'aria-label': 'search' }}
                                            sx={{ width: '100%', color: '##121926', backgroundColor: '#F8FAFC', borderRadius: '10px', border: '1px solid #Bdbdbd' }}
                                        />
                                    </Search>
                                </Box>
                                <Box className={ReqStyle.Box2}>
                                    Filter by
                                    <FormControl sx={{ m: 1, width: '200px' }}>
                                        <Select
                                            value={jobRole}
                                            // filter={job.careerJobRoleName}
                                            onChange={handleJobRoles}
                                            displayEmpty
                                            inputProps={{ "aria-label": "Without label" }}
                                            style={{ height: '5vh' }}
                                        >

                                            <MenuItem value="">All Roles</MenuItem>
                                            <MenuItem value='Corporate'>Corporate</MenuItem>
                                            <MenuItem value='Vendor'>Vendor</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>

                            </div>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow className={ReqStyle.Mainhead}>
                                        <TableCell className={ReqStyle.Tablehead}>Name</TableCell>
                                        <TableCell className={ReqStyle.Tablehead}>Phone No</TableCell>
                                        <TableCell className={ReqStyle.Tablehead}>Type</TableCell>
                                        <TableCell className={ReqStyle.Tablehead}>Date</TableCell>
                                        <TableCell className={ReqStyle.Tablehead}>Action</TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {filteredData
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row) => {
                                            if (!row.approved && row.requested) {

                                                return (
                                                    <TableRow className={ReqStyle.MainRow} hover role="checkbox" tabIndex={-1} key={row?.userId} >
                                                        <TableCell className={ReqStyle.Tablerow1}> {row.name}<Box className={ReqStyle.Email}>{row?.email}</Box></TableCell>
                                                        <TableCell className={ReqStyle.Tablerow}>{row?.phoneNumber} </TableCell>
                                                        <TableCell className={ReqStyle.Tablerow}>{row?.roles?.name} </TableCell>
                                                        <TableCell className={ReqStyle.Tablerow}>{row?.dateCreated} </TableCell>
                                                        <TableCell className={ReqStyle.Tablerow}>{row?.action}
                                                            <Link variant="outlined" to={"/businessdetail"} state={{ data: row }}>
                                                                <Button variant="outlined" sx={{ textTransform: 'capitalize', color: 'black', borderColor: 'black' }} >View Details
                                                                </Button>
                                                            </Link>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }

                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15]}
                            component="div"
                            count={rowCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            style={{ paddingTop: '2%' }}
                        />
                    </Paper>
                </CardContent>
            </Card>

        </>
    );
}

export default AllRequest
